/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKnumberSelect from './src/numberSelect.vue'

XKnumberSelect.intall = function (Vue) {
  Vue.component(XKnumberSelect.anme, XKnumberSelect)
}

export default XKnumberSelect



// WEBPACK FOOTER //
// ./src/components/module/numberSelect/index.js